/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Codec_CopyInputs */

const en_audio_embed_export_codec_copy = /** @type {(inputs: Audio_Embed_Export_Codec_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy (no transcode)`)
};

const fr_audio_embed_export_codec_copy = /** @type {(inputs: Audio_Embed_Export_Codec_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copie (sans transcodage)`)
};

const de_audio_embed_export_codec_copy = /** @type {(inputs: Audio_Embed_Export_Codec_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren (keine Transkodierung)`)
};

const it_audio_embed_export_codec_copy = /** @type {(inputs: Audio_Embed_Export_Codec_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia (senza transcodifica)`)
};

const ru_audio_embed_export_codec_copy = /** @type {(inputs: Audio_Embed_Export_Codec_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирование (без перекодирования)`)
};

const es_audio_embed_export_codec_copy = /** @type {(inputs: Audio_Embed_Export_Codec_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar (sin transcodificar)`)
};

const zh_cn2_audio_embed_export_codec_copy = /** @type {(inputs: Audio_Embed_Export_Codec_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制（无需转码）`)
};

const ja_audio_embed_export_codec_copy = /** @type {(inputs: Audio_Embed_Export_Codec_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コピー（トランスコードなし）`)
};

const hi_audio_embed_export_codec_copy = /** @type {(inputs: Audio_Embed_Export_Codec_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कॉपी करें (ट्रांसकोड नहीं)`)
};

const pt_pt2_audio_embed_export_codec_copy = /** @type {(inputs: Audio_Embed_Export_Codec_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar (sem transcodificação)`)
};

/**
* | output |
* | --- |
* | "Copy (no transcode)" |
*
* @param {Audio_Embed_Export_Codec_CopyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_codec_copy = /** @type {((inputs?: Audio_Embed_Export_Codec_CopyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Codec_CopyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_codec_copy(inputs)
	if (locale === "de") return de_audio_embed_export_codec_copy(inputs)
	if (locale === "it") return it_audio_embed_export_codec_copy(inputs)
	if (locale === "ru") return ru_audio_embed_export_codec_copy(inputs)
	if (locale === "es") return es_audio_embed_export_codec_copy(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_codec_copy(inputs)
	if (locale === "ja") return ja_audio_embed_export_codec_copy(inputs)
	if (locale === "hi") return hi_audio_embed_export_codec_copy(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_codec_copy(inputs)
	return en_audio_embed_export_codec_copy(inputs)
});